<template>
   <div id="map-canvas"></div>
</template>

<script>
export default {
  name: 'GoogleMap'
}
</script>




// WEBPACK FOOTER //
// src/components/GoogleMap.vue